import { render, staticRenderFns } from "./EvaluatorOverviewByTag.vue?vue&type=template&id=6b277535&scoped=true&"
import script from "./EvaluatorOverviewByTag.vue?vue&type=script&lang=js&"
export * from "./EvaluatorOverviewByTag.vue?vue&type=script&lang=js&"
import style0 from "./EvaluatorOverviewByTag.vue?vue&type=style&index=0&id=6b277535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b277535",
  null
  
)

export default component.exports